module.exports = __webpack_public_path__ + "images/hooray.e4b7eea9a84ba1d38ce2.png";